"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DatePickerButton = exports.DateRangeDisplay = exports.dateRangeDisplayFactory = exports.formatIntervalForDisplay = void 0;
var R = __importStar(require("ramda"));
var ChevronRightIcon_1 = __importDefault(require("mdi-react/ChevronRightIcon"));
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../Button");
var Icons_1 = require("../Icons");
var index_1 = require("./index");
require("./DatePicker.css");
var fromInternalDateFormat = index_1._internal.fromInternalDateFormat, internalDateFormat = index_1._internal.internalDateFormat;
var isAbsent = function (val) { return R.isNil(val) || R.isEmpty(val); };
var dash = '\u2013'; // Unicode Character 'EN DASH' (U+2013)
var nonBreakSpace = '\u00a0'; // Unicode Character 'NO-BREAK SPACE' (U+00A0)
var toLocalizedFormat = R.curry(function (locale, dateTime) {
    return dateTime.toFormat('DD', { locale: locale });
});
var shortLocalizedDateFormatter = R.curry(function (toLocalizedFormat, date) {
    return isAbsent(date)
        ? "".concat(dash).concat(dash)
        : toLocalizedFormat(fromInternalDateFormat(date));
});
exports.formatIntervalForDisplay = R.curry(function (toLocalizedFormat, locale, interval) {
    if (isAbsent(interval)) {
        return "".concat(dash).concat(dash);
    }
    var start = interval[0], end = interval[1];
    var format = shortLocalizedDateFormatter(toLocalizedFormat(locale));
    var isSameDay = fromInternalDateFormat(end).diff(fromInternalDateFormat(start), 'day')
        .days === 0;
    return isSameDay
        ? format(start)
        : "".concat(format(start)).concat(nonBreakSpace).concat(dash).concat(nonBreakSpace).concat(format(fromInternalDateFormat(end).toFormat(internalDateFormat)));
});
var dateRangeDisplayFactory = function (toLocalizedFormat) {
    return function DateRangeDisplay(_a) {
        var locale = _a.locale, ranges = _a.ranges;
        var formatter = (0, exports.formatIntervalForDisplay)(toLocalizedFormat, locale);
        var base = ranges[0], comparison = ranges[1];
        if (comparison !== undefined) {
            return (react_1["default"].createElement("span", null,
                formatter(base),
                react_1["default"].createElement(Icons_1.CompareIcon, null),
                formatter(comparison)));
        }
        else {
            return react_1["default"].createElement("span", null, formatter(base));
        }
    };
};
exports.dateRangeDisplayFactory = dateRangeDisplayFactory;
exports.DateRangeDisplay = (0, exports.dateRangeDisplayFactory)(toLocalizedFormat);
var DatePickerButton = function (_a) {
    var expanded = _a.expanded, locale = _a.locale, ranges = _a.ranges, className = _a.className, DateRangeDisplay = _a.DateRangeDisplay, _b = _a.type, type = _b === void 0 ? 'inline-outline-secondary' : _b, restProps = __rest(_a, ["expanded", "locale", "ranges", "className", "DateRangeDisplay", "type"]);
    return (react_1["default"].createElement(Button_1.Button, __assign({}, restProps, { className: (0, classnames_1["default"])(className, { 'vs-date-picker-button-expanded': expanded }, 'vs-date-picker-button'), type: type }),
        react_1["default"].createElement(DateRangeDisplay, __assign({}, { locale: locale, ranges: ranges })),
        react_1["default"].createElement(ChevronRightIcon_1["default"], { className: "vs-expanded-icon" })));
};
exports.DatePickerButton = DatePickerButton;
exports.DatePickerButton.propTypes = {
    expanded: prop_types_1["default"].bool,
    children: prop_types_1["default"].node
};
exports.DatePickerButton.defaultProps = {
    DateRangeDisplay: exports.DateRangeDisplay
};
exports["default"] = exports.DatePickerButton;
